import {TextField} from '@mui/material';
import React from 'react';
import {Control, Controller, FieldValues} from 'react-hook-form';

interface Props {
  control: Control<FieldValues>;
  name: string;
  label?: string;
  required?: boolean;
  numbersOnly?: boolean;
}

const FormTextField = ({
  control,
  name,
  label,
  required,
  numbersOnly,
}: Props) => {
  const validationRules = {
    required: required ? `${label || 'This field'} is required` : undefined,
    ...(numbersOnly && {
      pattern: {
        value: /^[0-9]*$/,
        message: 'Please enter a valid number',
      },
    }),
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={validationRules}
      render={({field, fieldState: {error}}) => (
        <TextField
          label={label}
          variant="outlined"
          sx={{mb: 2}}
          fullWidth
          error={!!error}
          helperText={error ? error.message : ''}
          {...field}
        />
      )}
    />
  );
};

export default React.memo(FormTextField);
